import React from 'react';


function EIBenefitsHome(props: any) {
	   
  return (
   <div className="masthead">
			<h1>Benefits of Emotional Intelligence at Home</h1>
			
      <div className="separator"></div>
			<p>This lesson is still under development. Please come back later!</p>
			

			<div className="input-group">
                <div className="input-group-append content-btn-box">
                    <a href="/ei-course" className="content-btn">Back to the course</a>
                </div>
            </div>
      
      <div className="separator"></div>
      <div className="separator"></div>
      
   </div>
  )
}
export default EIBenefitsHome;

